import { Tooltip } from './Tooltip'

interface TabItem {
  id: string
  label: string
  indicator?: boolean
  indicatorTooltip?: string
}

interface TabMenuProps {
  tabs: TabItem[]
  activeTab: string
  onChange: (tabId: string) => void
}

interface TabProps {
  id: string
  label: string
  indicator?: boolean
  indicatorTooltip?: string
  selected: boolean
  onSelect: (tabId: string) => void
}

export function Tab({
  id,
  label,
  indicator = false,
  indicatorTooltip,
  selected,
  onSelect,
}: TabProps) {
  return (
    <button
      type="button"
      className={`flex h-full items-end border-b-[3px] text-xs font-medium transition-colors ${
        selected
          ? 'border-[color:var(--text-subtle)] text-default'
          : 'border-transparent text-muted hover:text-[color:var(--text-strong)]'
      }`}
      onClick={() => onSelect(id)}
    >
      <span className="mb-[6px] inline-flex items-center gap-1.5">
        {label}
        {indicator ? (
          <Tooltip variant="label" content={indicatorTooltip}>
            <span
              className="h-1.5 w-1.5 rounded-full bg-red-500"
              aria-hidden="true"
              data-tab-indicator
            />
          </Tooltip>
        ) : null}
      </span>
    </button>
  )
}

export function TabMenu({ tabs, activeTab, onChange }: TabMenuProps) {
  return (
    <div className="-mb-px flex h-[40px] items-end gap-4">
      {tabs.map((tab) => (
        <Tab
          key={tab.id}
          id={tab.id}
          label={tab.label}
          indicator={tab.indicator}
          indicatorTooltip={tab.indicatorTooltip}
          selected={activeTab === tab.id}
          onSelect={onChange}
        />
      ))}
    </div>
  )
}
